import { render, staticRenderFns } from "./BankPage.vue?vue&type=template&id=8166c774&scoped=true&"
import script from "./BankPage.vue?vue&type=script&lang=js&"
export * from "./BankPage.vue?vue&type=script&lang=js&"
import style0 from "./BankPage.vue?vue&type=style&index=0&id=8166c774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8166c774",
  null
  
)

export default component.exports